import React, { useEffect  , useState , useContext} from 'react';
import Context from '../../../context/context';
import Footer from "../../Footer/Footer";
import TopBaner from "../../TopBaner/topBaner";
import SideBar from "../../SideBar/sideBar";
import { fetchAirportsAndHours } from "../../../apiCall";

function TimeCalc() {
  const { state } = useContext(Context);

      useEffect(() => {
          // setAirportDataValue(state.recommendedHours);
          // console.log(state.recommendedHours, 'state.recommendedHours');
          getAirportDataValue();
          
          }, []);
  
        const [airportDataValue, setAirportDataValue] = useState([]);
      
        const getAirportDataValue = () => {
          fetchAirportsAndHours(function (response) {
            console.log(response , 'response')
            setAirportDataValue(response);
            if (!response.result || response == null) {
            } else {
            }
          });
        };

  return (
    <div style={{
      direction: "rtl",
    }}>
      <SideBar></SideBar>
      <TopBaner></TopBaner>
      <header
        style={{
          textAlign: "center",
          padding: "10px",
        }}
      >
        <p style={{ fontSize: "18px", margin: "10px 0" }}>
          המלצה על מספר שעות נסיעה ביציאה מאומן לפני ההמראה- לפי רשימת שדות תעופה : 
        </p>
      </header>

      <table
  border="1"
  style={{
    width: "50%",
    margin: "0 auto" ,
    borderCollapse: "collapse", 
  }}
>
  <thead>
    <tr>
      <th
        style={{
          padding: "8px",
          backgroundColor: "#f2f2f2",
          textAlign: "center" , 
          border: "1px solid #ddd",
        }}
      >
        מספר שעות ליציאה מאומן
      </th>
      <th
        style={{
          padding: "8px",
          backgroundColor: "#f2f2f2",
          textAlign: "center" ,
          border: "1px solid #ddd", 
        }}
      >
        שדה תעופה
      </th>
      <th
        style={{
          padding: "8px",
          backgroundColor: "#f2f2f2",
          textAlign: "center" ,
          border: "1px solid #ddd",
        }}
      >
        Airport
      </th>
    </tr>
  </thead>
  <tbody>
    {airportDataValue.map((entry, index) => (
      <tr key={index}>
        <td
          style={{
            padding: "8px",
            textAlign: "center",
            border: "1px solid #ddd",
          }}
        >
          {entry.hours}
        </td>
        <td
          style={{
            padding: "8px",
            textAlign: "center",
            border: "1px solid #ddd", 
          }}
        >
          {entry.airportHebrew}
        </td>
        <td
          style={{
            padding: "8px",
            textAlign: "center",
            border: "1px solid #ddd", 
          }}
        >
          {entry.airport}
        </td>
      </tr>
    ))}
  </tbody>
</table>


      <footer
        style={{
          textAlign: "center",
          padding: "10px",
          fontWeight: "bold",
        }}
      >
        <p> אין בהמלצה זו כל התחייבות על הגעה בזמן לטיסה .</p>
        <p> השעות הרשומות בטבלה הנ"ל הן המלצה בלבד, ונכתבו על סמך נסיון רב משנים קודמות . </p>
        <p>עם זאת , פאייכלה אינה נושאת באחריות על עיכובים חריגים בגבולות או כל עיכוב לא צפוי אחר . </p>
         <p>בברכת נסיעה טובה ובטוחה !</p>
         <p>צוות פאייכלה . </p>
      </footer>
      <Footer></Footer>
    </div>
  );
}

export default TimeCalc;
